import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchOptimization } from './optimizationAPI'; // Assume this API function accepts filters as a parameter.

const initialState = {
  data: [],
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

// Async thunk to fetch data with filters
export const fetchOptimizationDataWithFilters = createAsyncThunk(
  'optimization/fetchOptimizationDataWithFilters',
  async ({ filter = {}, options = {} }) => {
    const response = await fetchOptimization({ filter, options }); // Pass filters to the API    
    return response.data; // Assuming the API response contains a `data` field
  }
);

export const optimizationSlice = createSlice({
  name: 'optimization',
  initialState,
  reducers: {}, // No need for additional reducers in this simplified version
  extraReducers: (builder) => {
    builder
      .addCase(fetchOptimizationDataWithFilters.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchOptimizationDataWithFilters.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload; // Store the fetched data
      })
      .addCase(fetchOptimizationDataWithFilters.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message; // Store error message
      });
  },
});

// Selector to access the data and status
export const selectOptimizationData = (state) => state.optimization.data;
export const selectOptimizationStatus = (state) => state.optimization.status;
export const selectOptimizationError = (state) => state.optimization.error;

export default optimizationSlice.reducer;
